import React from "react";
import PropTypes from "prop-types";
import backgroundMobile from "../../assets/icons/backgroundMobile.svg";

const Banniere = ({
                      dataUser,
                      navItem
                  }) => {
    return (
        <div id={"banniere-mobile"}>
            <img id={"banniere-mobile-img"} src={backgroundMobile}/>
            <h2 id={"banniere-mobile-bienvenue"} className={"titleMobile1"}>
                Bonjour<br/>
                <span
                    className={"titleMobile2 nauticus"}
                    style={{textTransform: "capitalize"}}
                >
                          {dataUser.firstname && dataUser.firstname + " !"}
                          </span>
            </h2>
            <p
                id={"banniere-mobile-quote"}
                style={{display: ((navItem == "accueil") || (navItem == undefined)) ? "" : "none"}}
            >L’art de vivre consiste <br/>en un subtil
                mélange <br/>entre lâcher-prise et tenir
                bon.<br/>Henri Lewis &#128521;</p>
        </div>
    );
};

Banniere.propTypes = {
    dataUser: PropTypes.object,
    navItem: PropTypes.object
};

export default Banniere;